<template>
  <div class="wrapper">
    <cirdHeader v-if="comeFromOldSystem" />
    <cird-header-out v-else />
    <router-view style="flex-grow: 1" />
    <CirdFooter v-if="!comeFromOldSystem" />
  </div>
</template>

<script>

import cirdHeader from '@/modules/common/header/header'
import cirdHeaderOut from '@/modules/common/header/header.out'
import CirdFooter from '@/modules/common/footer/footer.out'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    cirdHeader,
    cirdHeaderOut,
    CirdFooter
  },
  computed: {
    ...mapState({
      comeFromOldSystem: 'comeFromOldSystem'
    })
  },
  watch: {
  },
  created () {
  },
  mounted () { },
  updated () {
  },
  methods: {

  }
}
</script>




// WEBPACK FOOTER //
// src/pages/other-index.vue